import React from 'react';
import { Modal, ModalHeader } from 'reactstrap';
import { DeleteSpecialty } from './DeleteSpecialty';
import { FormSpecialty } from './FormSpecialty';
import { Dialog } from 'primereact/dialog';

export const ModalSpecialty = (props) => {

    const {
        modal, toggle, method, loading,
        name, handleInputChange, validaciones,
        saveCreate, saveUpdate, saveDelete, closeModalSpeciality
    } = props;

    const title =
        method === "create"
            ? "Registrar Especialidad"
            : method === "update"
                ? "Actualizar Especialidad"
                : "Eliminar Especialidad";

    const dialogClassName =
        method === "delete"
            ? "medium-dialog delete-method"
            : "small-dialog "; 


    return (

        <Dialog
            header={title}
            visible={modal}
            onHide={closeModalSpeciality}
            className={dialogClassName}
            blockScroll={true}
            modal
            closable={true}
            dismissableMask  
        >

            {
                method === "create" ?
                    <FormSpecialty
                        button="Crear nuevo especialidad"
                        {...{ toggle, loading, name, handleInputChange, validaciones, methodAction: saveCreate, closeModalSpeciality }}
                    />
                    : (method === "update") ?
                        <FormSpecialty
                            button="Actualizar especialidad"
                            {...{ toggle, loading, name, handleInputChange, validaciones, methodAction: saveUpdate, closeModalSpeciality }}
                        />
                        : <DeleteSpecialty {...{ toggle, loading, name, saveDelete }} />
            }
        </Dialog>
    )
}
